// extracted by mini-css-extract-plugin
module.exports = {"container":"ThemeToggle_container__F_FM7","spacer":"ThemeToggle_spacer__S8fRh","ThemeToggle":"ThemeToggle_ThemeToggle__O__iN","dot":"ThemeToggle_dot__s5V3B"};